import { IGraphsState, TRegionGraph } from '../../../types/redux';
import { getLabel } from './getLabel';

export function getDatasets(graphsData: IGraphsState, regionGraph: TRegionGraph) {
  const { data } = graphsData;

  if (data) {
    return data.graphs[regionGraph].datasets.map(dataset => {
      return {
        data: dataset.data,
        label: getLabel(dataset.region),
      };
    });
  }

  return [];
}
